// extracted by mini-css-extract-plugin
module.exports = {"container":"IQA_container__1ql_W","title":"IQA_title__3vwtw","sub-title":"IQA_sub-title__3HvvZ","services":"IQA_services__24VCx","details-item":"IQA_details-item__2l2Mb"};